module.exports = __webpack_public_path__ + "img/payment_process_gif.329fa04.gif";